import type { SVGProps } from 'react'
const LinePlayCircleVideo = (
	props: SVGProps<SVGSVGElement> & { secondaryColor?: string },
) => (
	<svg
		width={props.width || 32}
		height={props.height || 32}
		viewBox={`0 0 ${props.width || 32} ${props.height || 32}`}
		fill={props.fill || 'none'}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
			fill={props.secondaryColor || 'transparent'}
			fillOpacity="0.4"
		/>
		<path
			d="M16.0003 2.66675C8.64699 2.66675 2.66699 8.64675 2.66699 16.0001C2.66699 23.3534 8.64699 29.3334 16.0003 29.3334C23.3537 29.3334 29.3337 23.3534 29.3337 16.0001C29.3337 8.64675 23.3537 2.66675 16.0003 2.66675ZM21.847 17.1334L14.7003 21.5334C14.487 21.6667 14.247 21.7334 14.0003 21.7334C13.7803 21.7334 13.5537 21.6801 13.3537 21.5667C12.9337 21.3334 12.6737 20.8867 12.6737 20.4001V11.5934C12.6737 11.1134 12.9337 10.6667 13.3537 10.4267C13.7737 10.1867 14.2937 10.2067 14.7003 10.4534L21.847 14.8534C22.247 15.1001 22.4803 15.5201 22.4803 15.9867C22.4803 16.4534 22.2403 16.8801 21.847 17.1201V17.1334Z"
			fill={props.color || 'white'}
		/>
	</svg>
)
export { LinePlayCircleVideo }
